import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import {
    defaultSidebarTimeFilterOptions,
    defaultSidebarTimeFilterSelectedOption,
    SidebarTimeFilter,
    SidebarTimeFilterType
} from '@/components/sideBar/filters/time-filter/sidebar-filters-time-filter.model'

@Component
export default class SidebarFiltersTimeFilterCompact extends Vue {
    @PropSync(
        'selectedOption',
        {
            type: Object,
            default: SidebarTimeFilterType.THIS_QUARTER
        })
    syncedSelectedOption!: SidebarTimeFilterType

    @Prop({ type: Object, default: defaultSidebarTimeFilterSelectedOption })
    defaultOption!: SidebarTimeFilterType

    @Prop({
        type: Array,
        default: () => defaultSidebarTimeFilterOptions()
    })
    options!: Array<SidebarTimeFilter>
}
